import { ProgressSpinner } from "primereact/progressspinner";
import "./index.css";

const Spinner = () => {
  return (
    <div className="spinner-container">
      <ProgressSpinner
        className="spinner-object"
        strokeWidth="8"
        animationDuration=".5s"
      />
    </div>
  );
};

export default Spinner;
